import httpClient from 'api/httpClient';

function initiateVerification() {
  return httpClient.post('/auth/phone-verify');
}

function verificateCode(verificationCode: string) {
  return httpClient.post('/auth/phone-verify/token', {
    verificationCode,
  });
}

export default {
  initiateVerification,
  verificateCode,
};
